import { Injectable, signal } from '@angular/core';

@Injectable({
    providedIn: 'root',
})
export class SessionExpiredService {
    readonly visible = signal(false);

    show(): void {
        if (!this.visible()) {
            this.visible.set(true);
        }
    }
}
